import i18n from 'utility/Translate/I18n';

type PromotionUntilParams = {
    countdown: number;
    promotionUntil?: string;
};

export const getPromotionText = ({
    countdown,
    promotionUntil,
}: PromotionUntilParams) => {
    const t = i18n.t;

    switch (true) {
        case countdown >= 2:
            return t('TRANS-only-n-days-left', { count: countdown });
        case countdown > 0:
            return t('TRANS-only-today-and-tomorrow');
        case countdown === 0:
            return t('TRANS-only-today');
        default:
            return t('TRANS-promotion-extended-until-date', {
                date: promotionUntil,
            });
    }
};
